import { Routes } from '@angular/router';
import { NotFoundComponent } from './not-found/not-found.component';
import { NewReleasesComponent } from './new-releases/new-releases.component';
import { AboutComponent } from './about/about.component';
import { AlbumComponent } from './album/album.component';
import { ArtistDiscographyComponent } from './artist-discography/artist-discography.component';
import { FavouritesComponent } from './favourites/favourites.component';
import { FavouriteAlbumsComponent } from './favourite-albums/favourite-albums.component';
import { FavouriteArtistsComponent } from './favourite-artists/favourite-artists.component';
import { PlaylistComponent } from './playlist/playlist.component';
import { SearchResultComponent } from './search-result/search-result.component';
import { SongSearchResultComponent } from './song-search-result/song-search-result.component';
import { RegisterComponent } from './register/register.component';
import { LoginComponent } from './login/login.component';
import { GuardAuthService } from './guard-auth.service';

export const routes: Routes = [
    { path: 'register', component: RegisterComponent },
    { path: 'login', component: LoginComponent },
    { path: 'new-releases', component: NewReleasesComponent, canActivate: [GuardAuthService] },
    { path: 'about', component: AboutComponent, canActivate: [GuardAuthService] },
    { path: 'album/:id', component: AlbumComponent, canActivate: [GuardAuthService] },
    { path: 'artist/:id', component: ArtistDiscographyComponent, canActivate: [GuardAuthService] },
    { path: 'favourites', component: FavouritesComponent, canActivate: [GuardAuthService] },
    { path: 'favourite-albums', component: FavouriteAlbumsComponent, canActivate: [GuardAuthService] },
    { path: 'favourite-artists', component: FavouriteArtistsComponent, canActivate: [GuardAuthService] },
    { path: 'playlist', component: PlaylistComponent, canActivate: [GuardAuthService] },
    { path: 'songs/:id', component: SongSearchResultComponent, canActivate: [GuardAuthService] },
    { path: 'search/:id', component: SearchResultComponent, canActivate: [GuardAuthService] },
    { path: '', redirectTo: '/new-releases', pathMatch: 'full' },
    { path: '**', component: NotFoundComponent },
];
